// Popover über der Knopfleiste (Prototyp E-Mail): Kopf mit Icon-Kachel, Titel (aus dem Code), optional
// eine Aktion rechts, Schließen. Escape schließt nur das Popover.
import type { KeyboardEvent, ReactNode } from 'react';
import { X, type Icon } from '@phosphor-icons/react';
import { FORM, GLANZ, POPOVER } from './form-stil';

export function FormPopover({ titel, icon: I, verlauf, rechts, breite = 300, ausrichtung = 'links', onSchliessen, children }: {
  titel: string;
  icon: Icon;
  verlauf: string;
  rechts?: ReactNode;
  breite?: number;
  ausrichtung?: 'links' | 'rechts';
  onSchliessen: () => void;
  children: ReactNode;
}) {
  const taste = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); onSchliessen(); }
  };
  return (
    <div role="dialog" aria-label={titel} onKeyDown={taste} className="pf-drop absolute flex flex-col" style={{
      zIndex: 20, bottom: 'calc(100% + 8px)', [ausrichtung === 'links' ? 'left' : 'right']: 12, width: breite, maxWidth: 'calc(100% - 24px)',
      gap: 8, padding: 10, borderRadius: 22, background: POPOVER.flaeche, boxShadow: POPOVER.schatten,
      backdropFilter: 'blur(30px)', WebkitBackdropFilter: 'blur(30px)', color: FORM.text,
    }}>
      <div className="flex items-center" style={{ gap: 8, padding: '2px 4px 0' }}>
        <span aria-hidden className="relative flex shrink-0 items-center justify-center overflow-hidden" style={{ width: 22, height: 22, borderRadius: 7, background: verlauf }}>
          <span className="absolute inset-0" style={{ background: GLANZ }} />
          <I size={12} weight="fill" color="#fff" className="relative" />
        </span>
        <span className="min-w-0 flex-1 truncate" style={{ fontSize: 11.5, fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)' }}>{titel}</span>
        {rechts}
        <button type="button" onClick={onSchliessen} aria-label="Schließen" data-tip="Schließen"
          className="flex shrink-0 cursor-pointer items-center justify-center rounded-full border-none" style={{ width: 24, height: 24, background: 'rgba(255,255,255,0.08)', color: FORM.text }}>
          <X size={10} weight="bold" />
        </button>
      </div>
      {children}
    </div>
  );
}

/** Zeile in einem Popover (Liste: Vorlage, Signatur, Briefpapier, Akten …). */
export function FormPopoverZeile({ label, unter, icon: I, iconFarbe, iconFlaeche, an, onClick, gesperrt, rechts, zweizeilig = false }: {
  label: string;
  unter?: string;
  icon?: Icon;
  iconFarbe?: string;
  iconFlaeche?: string;
  an?: boolean;
  onClick: () => void;
  gesperrt?: boolean;
  rechts?: ReactNode;
  /** #559: lange Namen (Dateien) auf bis zu zwei Zeilen umbrechen statt abschneiden */
  zweizeilig?: boolean;
}) {
  return (
    <button type="button" onClick={onClick} disabled={gesperrt} title={zweizeilig ? label : undefined}
      className="pf-zeile flex w-full cursor-pointer items-center border-none text-left disabled:cursor-not-allowed disabled:opacity-50"
      style={{ gap: 10, padding: '7px 9px', borderRadius: 12, font: 'inherit', color: FORM.text, background: an ? POPOVER.zeileAktiv : 'transparent' }}>
      {I && (
        <span aria-hidden className="flex shrink-0 items-center justify-center" style={{ width: 28, height: 28, borderRadius: 9, background: iconFlaeche ?? 'rgba(255,255,255,0.1)' }}>
          <I size={14} weight="fill" color={iconFarbe ?? 'rgba(255,255,255,0.75)'} />
        </span>
      )}
      <span className="flex min-w-0 flex-1 flex-col">
        <span className={zweizeilig ? undefined : 'truncate'} style={{ fontSize: 13, fontWeight: 700,
          ...(zweizeilig ? { display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' as const, overflow: 'hidden', overflowWrap: 'anywhere' as const } : {}) }}>{label}</span>
        {unter && <span className="truncate" style={{ fontSize: 11, fontWeight: 600, color: FORM.text3 }}>{unter}</span>}
      </span>
      {rechts}
    </button>
  );
}
